import Container from 'react-bootstrap/Container'
import Hoecke from './Hoecke';
import Navigation from './components/Navigation';

const App = () => {
  return(
    <>
      <Navigation />
      <main className='flex-shrink-0'>
        <Hoecke />
        <Container>
        <div className='mt-5 text-center'>
          <p className='lead'>
          Warum das brandgefährlich ist und was wir jetzt tun können
          </p>
          <a className='btn btn-lg btn-secondary' href="https://www.aufstehen-gegen-rassismus.de/hoecke-ist-ein-nazi/">
            Jetzt aktiv werden!
          </a>
        </div>
        </Container>
      </main>
    </>
  )
}

export default App;
